import React from "react";
import S3Image from "./S3Image";
import S3Video from "./S3Video";

export default ({ value, style, imgStyle }) => {
    const { id, filename, mediaType } = value;
    return <div style={style}>{mediaType === "IMAGE" ? <S3Image key={id} imgKey={filename} style={{ maxWidth: '100%', ...imgStyle }} /> : <S3Video key={id} filename={filename} style={{ maxWidth: '100%', ...imgStyle }} />}</div>
};
